const electric = [
    {
        path: '/electric/quality',
        name: 'electricQuality',
        component: () => import('@/view/electric/quality'),
    },
]
export default electric